import { createAction, props } from '@ngrx/store';
import { CheckinCommonState } from './checkin-common.state';

/** StateDetailsActions */
const ACTION_SET = '[CheckinCommon] set';
const ACTION_UPDATE = '[CheckinCommon] update';
const ACTION_RESET = '[CheckinCommon] reset';

/**
 * Clear the current store object and replace it with the new one
 */
export const setCheckinCommon = createAction(ACTION_SET, props<CheckinCommonState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateCheckinCommon = createAction(ACTION_UPDATE, props<Partial<CheckinCommonState>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetCheckinCommon = createAction(ACTION_RESET);
